// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Vero Software components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import VeroNavbar from "components/VeroNavbar";
import VeroFooter from "components/VeroFooter";

// Routes
import routes from "routes";

// Submits to Formspree (https://formspree.io/f/xqpayozy) and forwards to bob@verosw.com.
const FORMSPREE_ENDPOINT = "https://formspree.io/f/xqpayozy";

function Contact() {
  return (
    <MKBox>
      <VeroNavbar routes={routes} />
      <MKBox component="section" py={6}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={8}>
              <MKBox bgColor="surface" borderRadius="xl" shadow="lg" p={{ xs: 3, md: 5 }}>
                <MKTypography variant="h3" mb={1}>
                  Contact us
                </MKTypography>
                <MKTypography variant="body2" color="text" mb={3}>
                  For questions, including partnership opportunities, email{" "}
                  <MKTypography
                    component="a"
                    href="mailto:bob@verosw.com"
                    variant="body2"
                    color="info"
                    fontWeight="bold"
                  >
                    bob@verosw.com
                  </MKTypography>{" "}
                  or use the form below.
                </MKTypography>
                <MKBox
                  width="100%"
                  component="form"
                  action={FORMSPREE_ENDPOINT}
                  method="POST"
                  autoComplete="off"
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        variant="standard"
                        label="Full Name"
                        name="name"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <MKInput
                        type="email"
                        variant="standard"
                        label="Email"
                        name="email"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MKInput
                        variant="standard"
                        label="What can we help you with?"
                        placeholder="Describe your problem in at least 250 characters"
                        name="message"
                        InputLabelProps={{ shrink: true }}
                        multiline
                        fullWidth
                        rows={6}
                        required
                      />
                    </Grid>
                  </Grid>
                  <Grid container item justifyContent="center" xs={12} mt={5} mb={2}>
                    <MKButton type="submit" variant="gradient" color="info">
                      Send Message
                    </MKButton>
                  </Grid>
                </MKBox>
              </MKBox>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <VeroFooter />
    </MKBox>
  );
}

export default Contact;
